import { useQuery } from "@tanstack/react-query";

import { getAllCategories } from "@/api/category";
import { CategoryType } from "@/types/category";

import { Checkbox } from "@/components/ui/checkbox";
import { ScrollArea } from "@/components/ui/scroll-area";

interface Props {
  value: number[];
  onChange: (value: number[]) => void;
  title?: string;
  description?: string;
}

const CategoryMultiSelect: React.FC<Props> = ({
  value,
  onChange,
  title = "دسته بندی ها",
  description = "چند دسته بندی را انتخاب کنید"
}) => {
  const { data, isLoading } = useQuery({
    queryKey: ["category-options"],
    queryFn: () => getAllCategories({ page: 1, size: 100 })
  });

  const categories = data?.data ?? [];

  const toggleCategory = (categoryId: number) => {
    onChange(
      value.includes(categoryId)
        ? value.filter((selectedId) => selectedId !== categoryId)
        : [...value, categoryId]
    );
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-3">
        <label className="text-sm font-medium">{title}</label>
        <span className="text-xs text-slate-500">
          {value.length ? `${value.length} مورد انتخاب شده` : "بدون انتخاب"}
        </span>
      </div>
      <p className="text-xs text-slate-500">{description}</p>
      <ScrollArea className="h-56 rounded-lg border border-slate-200 bg-white p-3">
        <div className="space-y-2">
          {isLoading ? (
            <div className="py-6 text-center text-sm text-slate-500">
              در حال بارگذاری دسته بندی ها...
            </div>
          ) : categories.length ? (
            categories.map((category: CategoryType) => (
              <label
                key={category.id}
                className="flex cursor-pointer items-start gap-3 rounded-md border border-slate-200 px-3 py-2 transition-colors hover:border-primary/60 hover:bg-primary/5"
              >
                <Checkbox
                  checked={value.includes(category.id)}
                  onCheckedChange={() => toggleCategory(category.id)}
                  className="mt-0.5"
                />
                <span className="flex-1 text-sm">
                  <span className="block font-medium text-slate-700">
                    {category.name}
                  </span>
                  {category.description && (
                    <span className="mt-1 block text-xs text-slate-500">
                      {category.description}
                    </span>
                  )}
                </span>
              </label>
            ))
          ) : (
            <div className="py-6 text-center text-sm text-slate-500">
              دسته بندی ای یافت نشد
            </div>
          )}
        </div>
      </ScrollArea>
    </div>
  );
};

export default CategoryMultiSelect;
